export default __webpack_public_path__ + "static/media/high-res-logo.440eca14.webp";